export default __webpack_public_path__ + "static/eisenbah-f3c61883005af77e7b4126b0d92c0adc.jpg";